import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle, setDataModal, 
    FetchData, Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickNextStep = () => {

        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode} = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const {setShowForm, setStepApplilication} = globalStates
        

        const { FormRequestGlobal : {onResetForm}} = Forms

        onResetForm()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickFetchInfoApplication = async (idcredito, idcotizacion, idvehiculo, modeOpening) => {
        console.log('handleClickFetchInfoApplication');
        
        const { FormRequestGlobal: {onResetForm, setFormState,formState}} = Forms
        const { 
            fetchAllVehicles:{executeFetchAllVehicles}, 
            fetchInfoCredit:{executeFetchInfoCredit},
            fetchAllQuotes:{executeFetchAllQuotes},
            fetchInfoQuotes:{executeFetchInfoQuote},
            fetchAllFiles:{executeFetchAllFiles},
            fetchAllDeposits:{executeFetchAllDeposits}

        } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito,
            idcotizacion: idcotizacion,
            idvehiculo: idvehiculo,
        }))

        executeFetchAllVehicles()
        executeFetchInfoCredit()
        executeFetchAllQuotes()
        executeFetchInfoQuote()
        executeFetchAllFiles()
        executeFetchAllDeposits()
        handleClickShowForm(modeOpening)

    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {
        
        const { FormDeposit: {onResetForm}} = Forms


        const { fetchInfoDeposit:{setParamsToSearch, executeFetchInfoDeposit} } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddeposit: iddeposit})
        executeFetchInfoDeposit()


        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit, FormPreInvventory, FormInsuranceRenewal } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormInvventory = FormPreInvventory.onResetForm
        const onResetFormInsurance = FormInsuranceRenewal.onResetForm
        onResetForm()
        onResetFormInvventory() 
        onResetFormInsurance()
        closeModal()
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');
    
          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }
    
    }

    const handleClickFetchInfoPreInventory = async (idvehicledeposit, modeOpening) => {
        
        const { FormPreInvventory: {onResetForm}} = Forms

        const { fetchInfoPreInventory : {setParamsToSearch, executeFetchPreInventory} } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idvehicledeposit: idvehicledeposit})
        executeFetchPreInventory()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de Pre Inventario', 'preinventory-section', {}, modeOpening)

    }

    const handleClickGPSRemovalFee = async (idcredito ) => {

        const {fetchAllVehicleCredits:{executeFetchAllVehicleCredits}} = FetchData

        Swal.fire({
            title: '¿Está seguro de exonerar el pago de retiro de GPS?',
            text: 'Esta acción hará que el cliente no deba pagar el costo del tecnico para el retiro del dispositivo GPS',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Confirmar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/vehicle/admin-credits/gps-removal/${idcredito}`)
                .then(({ data }) => {
                    alertMessage(data)
                    executeFetchAllVehicleCredits()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }


    const handleClickInsuranceRenewal = async (idcredito) => {
        
        const { FormRequestGlobal: {setFormState}} = Forms

        const { fetchInfoInsurance : {executeFetchInfoInsurance} } = FetchData

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito
        }))

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        // onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        // setParamsToSearch({idvehicledeposit: idvehicledeposit})
        // executeFetchPreInventory()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        // console.log('handleClickInsuranceRenewal');
        executeFetchInfoInsurance()

        handleClickShowModal('', 'Renovacion de seguro', 'insurance-renewal-section', {}, 'EDITABLE')

    }

    const handleChangeTotalInsurance = (event) => {

        //HOOKS
        const {FormInsuranceRenewal:{setFormState, formState, onInputChangeForNumber}} = Forms
        const {check_cuotas, cuotas_restantes} = formState
        const {convertToFloat, numberFormatter} = Helpers

        const { value } = event.target

        const value_parse = convertToFloat(value)
        const nueva_cuota = (check_cuotas) ? (value_parse/cuotas_restantes) : (value_parse/12)

        onInputChangeForNumber(event)

        setFormState(prevState => ({
            ...prevState,
            cuota_nuevo_seguro : numberFormatter.format(nueva_cuota),
            // deposito_dolares : (monto),
        }))

    }

    const handleChangeCheckCuotas = (event) => {

        //HOOKS
        const {FormInsuranceRenewal:{setFormState, formState, onInputChangeForCheckBox}} = Forms
        const {clean_total_seguro, cuotas_restantes} = formState
        const {numberFormatter} = Helpers

        const { checked } = event.target

        const nueva_cuota = (checked) ? (clean_total_seguro/cuotas_restantes) : (clean_total_seguro/12)

        onInputChangeForCheckBox(event)

        setFormState(prevState => ({
            ...prevState,
            cuota_nuevo_seguro : numberFormatter.format(nueva_cuota),
            // deposito_dolares : (monto),
        }))

    }

    const onSubmitFormInsuranceRenewal = async (e) => {

        e.preventDefault()
      
        const { FormRequestGlobal:{formState}, FormInsuranceRenewal } = Forms
        const {getCurrentDate, convertToFloat} = Helpers
        const formStateInsurance =  FormInsuranceRenewal.formState
        const {fetchAllVehicleCredits : {executeFetchAllVehicleCredits}} = FetchData

        // const {fetchAllFiles:{executeFetchAllFiles}, fetchInfoApplication:{executeFetchInfoApplication}} = FetchData
        const nueva_cuota = convertToFloat(formStateInsurance.cuota_nuevo_seguro)
        const body = {
            idcredito: formState.idcredito,
            cuota_nuevo_seguro: nueva_cuota, 
            check_cuotas: (formStateInsurance.check_cuotas) ? 1 : 0, 
            usuario_modifico: user.username,
            fecha_modifico: getCurrentDate()
        }


        if(formState.idcredito>0){
            
            await marvarApi.post( `/vehicle/admin-credits/insurance-renewal`, body )
                .then(async ({ data }) => {
                    
                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllVehicleCredits()
                        handleClickCloseModal()
                    }
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
            })
        }
    }

    const handleClickGPSRenewal = async (idcredito) => {
        
        const { FormRequestGlobal: {setFormState}} = Forms

        const { fetchInfoGPS : {executeFetchInfoGPS} } = FetchData

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito
        }))

        executeFetchInfoGPS()

        handleClickShowModal('', 'Renovacion de GPS', 'gps-renewal-section', {}, 'EDITABLE')

    }

    const handleChangeTotalGPS = (event) => {

        //HOOKS
        const {FormGPSRenewal:{setFormState, formState, onInputChangeForNumber}} = Forms
        const {check_cuotas, cuotas_restantes} = formState
        const {convertToFloat, numberFormatter} = Helpers

        const { value } = event.target

        const value_parse = convertToFloat(value)
        const nueva_cuota = (check_cuotas) ? (value_parse/cuotas_restantes) : (value_parse/12)

        onInputChangeForNumber(event)

        setFormState(prevState => ({
            ...prevState,
            cuota_nuevo_gps : numberFormatter.format(nueva_cuota),
        }))

    }

    const handleChangeCheckCuotasGPS = (event) => {

        //HOOKS
        const {FormGPSRenewal:{setFormState, formState, onInputChangeForCheckBox}} = Forms
        const {clean_total_gps, cuotas_restantes} = formState
        const {numberFormatter} = Helpers

        const { checked } = event.target

        const nueva_cuota = (checked) ? (clean_total_gps/cuotas_restantes) : (clean_total_gps/12)

        onInputChangeForCheckBox(event)

        setFormState(prevState => ({
            ...prevState,
            cuota_nuevo_gps : numberFormatter.format(nueva_cuota),
        }))

    }

    const onSubmitFormGPSRenewal = async (e) => {

        e.preventDefault()
      
        const { FormRequestGlobal:{formState}, FormGPSRenewal } = Forms
        const {getCurrentDate, convertToFloat} = Helpers
        const formStateGPS =  FormGPSRenewal.formState
        const {fetchAllVehicleCredits : {executeFetchAllVehicleCredits}} = FetchData


        const nueva_cuota = convertToFloat(formStateGPS.cuota_nuevo_gps)
        const body = {
            idcredito: formState.idcredito,
            cuota_nuevo_gps: nueva_cuota, 
            check_cuotas: (formStateGPS.check_cuotas) ? 1 : 0, 
            usuario_modifico: user.username,
            fecha_modifico: getCurrentDate()
        }


        if(formState.idcredito>0){
            
            await marvarApi.post( `/vehicle/admin-credits/gps-renewal`, body )
                .then(async ({ data }) => {
                    
                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllVehicleCredits()
                        handleClickCloseModal()
                    }
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
        }
    }

    const handleClickShowExpenses = (idcredito) => {
        const { setShowExpenses} = globalStates
        const { FormRequestGlobal: {setFormState} } = Forms

        const {fetchAllAdminExpenses:{executeFetchAllExpenses}} = FetchData

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito
        }))

        setShowExpenses(true)
        executeFetchAllExpenses()
    }

    const handleClickCloseExpenses = () => {

        const {setShowExpenses} = globalStates

        // const {FormExpenses:{onResetForm}} = Forms
        
        // onResetForm()

        setShowExpenses(false)
    
    }

    const handleClickFetchInfoExpenses = async () => {

        handleClickShowModal('', 'Formulario de gastos', 'expenses-section', {}, 'EDITABLE')

    }

    const onSubmitFormExpenses = async (e) => {

        e.preventDefault()
    
        const { FormExpenses: { formState, onResetForm, setFormState }, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const {getCurrentDate} = Helpers
    
        const {fetchAllAdminExpenses:{executeFetchAllExpenses}} = FetchData

        if(formStateGlobal.idcredito>0){

            const body = {
                idusuario: user.uid,
                gasto_fecha: formState.gasto_fecha,
                gasto_descripcion: formState.gasto_descripcion,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate(),
                gasto_monto: formState.clean_gasto_monto
            }

            await marvarApi.post( `/vehicle/admin-credits/create-expense/${formStateGlobal.idcredito}`, body )
            .then(({ data }) => {
    
                alertMessage(data)
    
                if (data.title === 'OK') {
                    onResetForm()
                    executeFetchAllExpenses()
                    closeModal()
                }
                
            })
            .catch(error => {
                    console.log('API ERROR: ', error)
            })
        }
    }

        const handleButtonDeleteExpenses = (idgasto) => {
    
            const {fetchAllAdminExpenses:{executeFetchAllExpenses}} = FetchData
    
            Swal.fire({
                title: '¿Desea eliminar este registro?',
                text: 'Esta acción elimara el gasto asociado al credito de vehiculo',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ff6219',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async result => {
                if (result.isConfirmed) {
                    await marvarApi.delete(`/vehicle/admin-credits/delete-expense/${idgasto}`)
                    .then( async ({ data }) => {
                        alertMessage(data)
                        executeFetchAllExpenses()
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
                }
            })
        }

    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchInfoApplication,
        handleClickNextStep,
        handleClickReturnStep,
        handleClickFetchInfoDeposit,
        handleClickCloseModal,
        handleClickDownloadImage,
        handleClickFetchInfoPreInventory,
        handleClickGPSRemovalFee,
        handleClickInsuranceRenewal,
        handleChangeTotalInsurance,
        handleChangeCheckCuotas,
        onSubmitFormInsuranceRenewal,
        handleClickGPSRenewal,
        handleChangeTotalGPS,
        handleChangeCheckCuotasGPS,
        onSubmitFormGPSRenewal,
        handleClickShowExpenses,
        handleClickCloseExpenses,
        handleClickFetchInfoExpenses,
        onSubmitFormExpenses,
        handleButtonDeleteExpenses,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}